import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const keycloakTokenEndpoint = "https://ncjp.psanalytics.co.uk/auth/realms/ncjp/protocol/openid-connect/token";
const clientId = "ncjp-app";
const clientSecret = "1ZtA2aRuuAt9RMMVeNTnPPJXP5p9Eo5q"; // If required
const redirectUri = "https://ncjp.psanalytics.co.uk/login-only-callback"; // This page

const LoginOnlyCallback: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const authCode = params.get("code");

    if (!authCode) {
      console.error("Missing authorization code!");
      navigate("/invite?error=missing_code");
      return;
    }

    const fetchToken = async () => {
      try {
        console.log("Fetching Keycloak token...");

        const response = await fetch(keycloakTokenEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            client_id: clientId,
            client_secret: clientSecret,
            grant_type: "authorization_code",
            redirect_uri: redirectUri,
            code: authCode,
            scope: "openid email profile",
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to exchange code for token");
        }

        const data = await response.json();

        // Log all token properties with their names.
        console.log("Keycloak Token Response:");
        Object.entries(data).forEach(([key, value]) => {
          console.log(`${key}: ${value}`);
        });

        const { access_token, id_token } = data;

        // Save the id_token to localStorage as "Id_token"
        if (id_token) {
          localStorage.setItem("id_token", id_token);
          console.log("id_token saved to localStorage as Id_token.");
        } else {
          console.warn("id_token not found in token response.");
        }

        // Decode the access token to extract the user's subject (sub)
        const payload = JSON.parse(atob(access_token.split(".")[1]));
        const oneLoginSub = payload.sub;
        console.log("Authenticated User Sub:", oneLoginSub);

        // Store other authentication details in localStorage
        localStorage.setItem("token", access_token);
        localStorage.setItem("userId", oneLoginSub);
        localStorage.setItem("oneLoginSub", oneLoginSub);

        console.log("Login successful. Redirecting to Dashboard...");
        navigate("/");
      } catch (error: any) {
        console.error("Error during authentication:", error);
        navigate("/invite?error=auth_failed");
      }
    };

    fetchToken();
  }, [location, navigate]);

  return <div>Processing login, please wait...</div>;
};

export default LoginOnlyCallback;
